import React, { Component } from "react";

import Overview_overview from "../../components/knowlege/overview/Overview_overview";
import Database_overview from "../../components/knowlege/overview/Database_overview";
import Database_naming from "../../components/knowlege/overview/Database_naming";

import API_overview from "../../components/knowlege/api/API_overview";
import Response_codes from "../../components/knowlege/api/Response_codes";
import Postman from "../../components/knowlege/api/Postman";
import Url from "../../components/knowlege/api/Url";
import Sign_in from "../../components/knowlege/api/Sign_in";
import Sign_out from "../../components/knowlege/api/Sign_out";
import Change_password from "../../components/knowlege/api/Change_password";
import Authenticator from "../../components/knowlege/api/Authenticator";
import Record_overview from "../../components/knowlege/api/Record_overview";
import Create_record from "../../components/knowlege/api/Create_record";
import Read_record from "../../components/knowlege/api/Read_record";
import Update_record from "../../components/knowlege/api/Update_record";
import Replace_record from "../../components/knowlege/api/Replace_record";
import Delete_record from "../../components/knowlege/api/Delete_record";
import Search_records from "../../components/knowlege/api/Search_records";
import Count_records from "../../components/knowlege/api/Count_records";

import View_record_audit from "../../components/knowlege/api/View_record_audit";
import Delete_record_audit from "../../components/knowlege/api/Delete_record_audit";
import Attachments_overview from "../../components/knowlege/api/Attachments_overview";
import Attachments_upload from "../../components/knowlege/api/Attachments_upload";
import Attachments_rename from "../../components/knowlege/api/Attachments_rename";
import Attachments_delete from "../../components/knowlege/api/Attachments_delete";
import Attachments_search from "../../components/knowlege/api/Attachments_search";
import Notifications_overview from "../../components/knowlege/api/Notifications_overview";
import Notifications_create from "../../components/knowlege/api/Notifications_create";
import Notifications_view from "../../components/knowlege/api/Notifications_view";
import Notifications_mark_as_read from "../../components/knowlege/api/Notifications_mark_as_read";
import Email_overview from "../../components/knowlege/api/Email_overview";
import Send_email from "../../components/knowlege/api/Send_email";
import SMS_overview from "../../components/knowlege/api/SMS_overview";
import Send_SMS from "../../components/knowlege/api/Send_SMS";
import PDF_overview from "../../components/knowlege/api/PDF_overview";
import PDF_create from "../../components/knowlege/api/PDF_create";
import System_overview from "../../components/knowlege/api/System_overview";
import System_objects from "../../components/knowlege/api/System_objects";

import Interface_overview from "../../components/knowlege/interface/Interface_overview";
import Working_with_JSON from "../../components/knowlege/interface/Working_with_JSON";
import Inheritance_hierarchy from "../../components/knowlege/interface/Inheritance_hierarchy";
import Importing_and_exporting from "../../components/knowlege/interface/Importing_and_exporting";
import Layout_overview from "../../components/knowlege/interface/Layout_overview";
import Layout_structure from "../../components/knowlege/interface/Layout_structure";
import Layout_action_menus from "../../components/knowlege/interface/Layout_action_menus";
import Layout_create_options from "../../components/knowlege/interface/Layout_create_options";
import Layout_tab_menu from "../../components/knowlege/interface/Layout_tab_menu";

import Component_overview from "../../components/knowlege/interface/Component_overview";
import Information_component_overview from "../../components/knowlege/interface/Information_component_overview";
import Component_information_heading from "../../components/knowlege/interface/Component_information_heading";
import Component_information_paragraph from "../../components/knowlege/interface/Component_information_paragraph";
import Record_component_overview from "../../components/knowlege/interface/Record_component_overview";
import Component_record_attachments from "../../components/knowlege/interface/Component_record_attachments";
import Component_record_button from "../../components/knowlege/interface/Component_record_button";
import Component_record_button_set from "../../components/knowlege/interface/Component_record_button_set";
import Component_record_checkbox from "../../components/knowlege/interface/Component_record_checkbox";
import Component_record_code_editor from "../../components/knowlege/interface/Component_record_code_editor";
import Component_record_drag_and_drop_list from "../../components/knowlege/interface/Component_record_drag_and_drop_list";
import Component_record_keywords from "../../components/knowlege/interface/Component_record_keywords";
import Component_record_notes from "../../components/knowlege/interface/Component_record_notes";
import Component_record_select_date from "../../components/knowlege/interface/Component_record_select_date";
import Component_record_select_list from "../../components/knowlege/interface/Component_record_select_list";
import Component_record_select_object from "../../components/knowlege/interface/Component_record_select_object";
import Component_record_textbox from "../../components/knowlege/interface/Component_record_textbox";
import Component_record_textbox_list from "../../components/knowlege/interface/Component_record_textbox_list";
import Component_record_timestamp from "../../components/knowlege/interface/Component_record_timestamp";
import Component_record_eval from "../../components/knowlege/interface/Component_record_eval";
import Search_component_overview from "../../components/knowlege/interface/Search_component_overview";
import Component_search_filter_date_range from "../../components/knowlege/interface/Component_search_filter_date_range";
import Component_search_filter_field from "../../components/knowlege/interface/Component_search_filter_field";
import Component_search_filter_foreign_object from "../../components/knowlege/interface/Component_search_filter_foreign_object";
import Component_search_filter_number_range from "../../components/knowlege/interface/Component_search_filter_number_range";
import Component_search_free_text from "../../components/knowlege/interface/Component_search_free_text";
import Component_search_reset from "../../components/knowlege/interface/Component_search_reset";
import Component_search_results from "../../components/knowlege/interface/Component_search_results";
import Component_search_sort from "../../components/knowlege/interface/Component_search_sort";

import Report_component_overview from "../../components/knowlege/interface/Report_component_overview";
import Component_report_table from "../../components/knowlege/interface/Component_report_table";
import Component_report_html from "../../components/knowlege/interface/Component_report_html";

import Dashboard_component_overview from "../../components/knowlege/interface/Dashboard_component_overview";
import Component_dashboard_bar_chart from "../../components/knowlege/interface/Component_dashboard_bar_chart";
import Component_dashboard_doughnut_chart from "../../components/knowlege/interface/Component_dashboard_doughnut_chart";
import Component_dashboard_horizontal_bar_chart from "../../components/knowlege/interface/Component_dashboard_horizontal_bar_chart";
import Component_dashboard_line_chart from "../../components/knowlege/interface/Component_dashboard_line_chart";
import Component_dashboard_pie_chart from "../../components/knowlege/interface/Component_dashboard_pie_chart";
import Component_dashboard_polar_chart from "../../components/knowlege/interface/Component_dashboard_polar_chart";

import Material_colors from "../../components/knowlege/interface/Material_colors";
import Material_icons from "../../components/knowlege/interface/Material_icons";

import Workflow_Overview from "../../components/knowlege/workflow/Workflow_Overview";
import Application_Events from "../../components/knowlege/workflow/Application_Events";
import Workflow_Events from "../../components/knowlege/workflow/Workflow_Events";
import NL_Overview from "../../components/knowlege/workflow/NL_Overview";
import NL_Interface_getQueryString from "../../components/knowlege/workflow/NL_Interface_getQueryString";
import NL_Interface_getQueryStringObject from "../../components/knowlege/workflow/NL_Interface_getQueryStringObject";
import NL_Interface_isQueryString from "../../components/knowlege/workflow/NL_Interface_isQueryString";
import NL_Interface_navigateTo from "../../components/knowlege/workflow/NL_Interface_navigateTo";
import NL_Interface_updateRecord from "../../components/knowlege/workflow/NL_Interface_updateRecord";
import NL_Record_create from "../../components/knowlege/workflow/NL_Record_create";
import NL_Record_read from "../../components/knowlege/workflow/NL_Record_read";
import NL_Record_update from "../../components/knowlege/workflow/NL_Record_update";
import NL_Record_replace from "../../components/knowlege/workflow/NL_Record_replace";
import NL_Record_delete from "../../components/knowlege/workflow/NL_Record_delete";
import NL_Record_search from "../../components/knowlege/workflow/NL_Record_search";
import NL_Record_audit_delete from "../../components/knowlege/workflow/NL_Record_audit_delete";
import NL_Authentication_authenticator from "../../components/knowlege/workflow/NL_Authentication_authenticator";
import NL_Notification_create from "../../components/knowlege/workflow/NL_Notification_create";
import NL_Notification_view from "../../components/knowlege/workflow/NL_Notification_view";
import NL_Notification_markAsRead from "../../components/knowlege/workflow/NL_Notification_markAsRead";
import NL_Email_send from "../../components/knowlege/workflow/NL_Email_send";
import NL_PDF_create from "../../components/knowlege/workflow/NL_PDF_create";
import NL_SMS_send from "../../components/knowlege/workflow/NL_SMS_send";
import NL_Geo_get from "../../components/knowlege/workflow/NL_Geo_get";

import NL_S3_init from "../../components/knowlege/workflow/NL_S3_init";
import NL_S3_delete from "../../components/knowlege/workflow/NL_S3_delete";
import NL_S3_delete_files from "../../components/knowlege/workflow/NL_S3_delete_files";
import NL_S3_download from "../../components/knowlege/workflow/NL_S3_download";
import NL_S3_download_files from "../../components/knowlege/workflow/NL_S3_download_files";
import NL_S3_list from "../../components/knowlege/workflow/NL_S3_list";
import NL_S3_upload from "../../components/knowlege/workflow/NL_S3_upload";
import NL_S3_upload_files from "../../components/knowlege/workflow/NL_S3_upload_files";
import NL_Translate_init from "../../components/knowlege/workflow/NL_Translate_init";
import NL_Translate_translate from "../../components/knowlege/workflow/NL_Translate_translate";
import NL_Translate_saveCache from "../../components/knowlege/workflow/NL_Translate_saveCache";

import Security_overview from "../../components/knowlege/security/Security_overview";
import System_permissions from "../../components/knowlege/security/System_permissions";

import Permissions_objects from "../../components/knowlege/security/Permissions_objects";
import Permissions_RLP from "../../components/knowlege/security/Permissions_RLP";
import Permissions_RLP_Settings from "../../components/knowlege/security/Permissions_RLP_Settings";

import Integration_Overview from "../../components/knowlege/integration/Integration_Overview";
import Nexoid_Agent from "../../components/knowlege/integration/Nexoid_Agent";
import Nexoid_Agent_SSO from "../../components/knowlege/integration/Nexoid_Agent_SSO";
import Tools_node_js_2_json from "../../components/knowlege/integration/Tools_node_js_2_json";
import { Scrollbars } from "react-custom-scrollbars";

class Knowlege extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  show(props, section, article) {
    var ps = props.section;
    var pa = props.article;
    if (typeof ps === "string") {
      ps = ps.toLowerCase();
    }
    if (typeof pa === "string") {
      pa = pa.toLowerCase();
    }
    if (typeof section === "string") {
      section = section.toLowerCase();
    }
    if (typeof article === "string") {
      article = article.toLowerCase();
    }
    if (ps === section && pa === article) {
      return true;
    } else if (ps === section && pa === undefined) {
      return true;
    } else {
      return false;
    }
  }

  render() {
    return (
      <div style={{ height: "100%" }}>
        <Scrollbars
          style={{ height: "100%" }}
          renderThumbVertical={(props) => (
            <div {...props} className="thumb-vertical" />
          )}
          renderView={(props) => (
            <div {...props} style={{ ...props.style, overflowX: "hidden" }} />
          )}
          renderTrackHorizontal={(props) => (
            <div
              {...props}
              style={{ display: "none" }}
              className="track-horizontal"
            />
          )}
        >
          {this.show(this.props, "overview", "overview") ? (
            <Overview_overview
              section={"overview"}
              article={"overview"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "overview", "database_overview") ? (
            <Database_overview
              section={"overview"}
              article={"database_overview"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "overview", "database_naming") ? (
            <Database_naming
              section={"overview"}
              article={"database_naming"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "api", "api_overview") ? (
            <API_overview
              section={"api"}
              article={"api_overview"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "api", "url") ? (
            <Url
              section={"api"}
              article={"url"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "api", "postman") ? (
            <Postman
              section={"api"}
              article={"postman"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "api", "response_codes") ? (
            <Response_codes
              section={"api"}
              article={"response_codes"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "api", "sign_in") ? (
            <Sign_in
              section={"api"}
              article={"sign_in"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "api", "sign_out") ? (
            <Sign_out
              section={"api"}
              article={"sign_out"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "api", "change_password") ? (
            <Change_password
              section={"api"}
              article={"change_password"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "api", "authenticator") ? (
            <Authenticator
              section={"api"}
              article={"authenticator"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "api", "record_overview") ? (
            <Record_overview
              section={"api"}
              article={"record_overview"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "api", "create_record") ? (
            <Create_record
              section={"api"}
              article={"create_record"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "api", "read_record") ? (
            <Read_record
              section={"api"}
              article={"read_record"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "api", "update_record") ? (
            <Update_record
              section={"api"}
              article={"update_record"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "api", "replace_record") ? (
            <Replace_record
              section={"api"}
              article={"replace_record"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "api", "delete_record") ? (
            <Delete_record
              section={"api"}
              article={"delete_record"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "api", "search_records") ? (
            <Search_records
              section={"api"}
              article={"search_records"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "api", "count_records") ? (
            <Count_records
              section={"api"}
              article={"count_records"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "api", "view_record_audit") ? (
            <View_record_audit
              section={"api"}
              article={"view_record_audit"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "api", "delete_record_audit") ? (
            <Delete_record_audit
              section={"api"}
              article={"delete_record_audit"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "api", "attachments_overview") ? (
            <Attachments_overview
              section={"api"}
              article={"attachments_overview"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "api", "attachments_upload") ? (
            <Attachments_upload
              section={"api"}
              article={"attachments_upload"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "api", "attachments_rename") ? (
            <Attachments_rename
              section={"api"}
              article={"attachments_rename"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "api", "attachments_delete") ? (
            <Attachments_delete
              section={"api"}
              article={"attachments_delete"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "api", "attachments_search") ? (
            <Attachments_search
              section={"api"}
              article={"attachments_search"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "api", "notifications_overview") ? (
            <Notifications_overview
              section={"api"}
              article={"notifications_overview"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "api", "notifications_create") ? (
            <Notifications_create
              section={"api"}
              article={"notifications_create"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "api", "notifications_view") ? (
            <Notifications_view
              section={"api"}
              article={"notifications_view"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "api", "notifications_mark_as_read") ? (
            <Notifications_mark_as_read
              section={"api"}
              article={"notifications_mark_as_read"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "api", "email_overview") ? (
            <Email_overview
              section={"api"}
              article={"email_overview"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "api", "send_email") ? (
            <Send_email
              section={"api"}
              article={"send_email"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "api", "pdf_overview") ? (
            <PDF_overview
              section={"api"}
              article={"pdf_overview"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "api", "pdf_create") ? (
            <PDF_create
              section={"api"}
              article={"pdf_create"}
              routeParams={this.props.routeParams}
            />
          ) : null}

          {this.show(this.props, "api", "sms_overview") ? (
            <SMS_overview
              section={"api"}
              article={"sms_overview"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "api", "send_sms") ? (
            <Send_SMS
              section={"api"}
              article={"send_sms"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "api", "system_overview") ? (
            <System_overview
              section={"api"}
              article={"system_overview"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "api", "system_objects") ? (
            <System_objects
              section={"api"}
              article={"system_objects"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "interface", "interface_overview") ? (
            <Interface_overview
              section={"interface"}
              article={"interface_overview"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "interface", "working_with_json") ? (
            <Working_with_JSON
              section={"interface"}
              article={"working_with_json"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "interface", "inheritance_hierarchy") ? (
            <Inheritance_hierarchy
              section={"interface"}
              article={"inheritance_hierarchy"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "interface", "importing_and_exporting") ? (
            <Importing_and_exporting
              section={"interface"}
              article={"importing_and_exporting"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "interface", "layout_overview") ? (
            <Layout_overview
              section={"interface"}
              article={"layout_overview"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "interface", "layout_structure") ? (
            <Layout_structure
              section={"interface"}
              article={"layout_structure"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "interface", "layout_action_menus") ? (
            <Layout_action_menus
              section={"interface"}
              article={"layout_action_menus"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "interface", "layout_create_options") ? (
            <Layout_create_options
              section={"interface"}
              article={"layout_create_options"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "interface", "layout_tab_menu") ? (
            <Layout_tab_menu
              section={"interface"}
              article={"layout_tab_menu"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "interface", "component_overview") ? (
            <Component_overview
              section={"interface"}
              article={"component_overview"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "interface", "component_record_eval") ? (
            <Component_record_eval
              section={"interface"}
              article={"component_record_eval"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(
            this.props,
            "interface",
            "information_component_overview"
          ) ? (
            <Information_component_overview
              section={"interface"}
              article={"information_component_overview"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(
            this.props,
            "interface",
            "component_information_heading"
          ) ? (
            <Component_information_heading
              section={"interface"}
              article={"component_information_heading"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(
            this.props,
            "interface",
            "component_information_paragraph"
          ) ? (
            <Component_information_paragraph
              section={"interface"}
              article={"component_information_paragraph"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "interface", "record_component_overview") ? (
            <Record_component_overview
              section={"interface"}
              article={"record_component_overview"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(
            this.props,
            "interface",
            "component_record_attachments"
          ) ? (
            <Component_record_attachments
              section={"interface"}
              article={"component_record_attachments"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "interface", "component_record_button") ? (
            <Component_record_button
              section={"interface"}
              article={"component_record_button"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "interface", "component_record_button_set") ? (
            <Component_record_button_set
              section={"interface"}
              article={"component_record_button_set"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "interface", "component_record_checkbox") ? (
            <Component_record_checkbox
              section={"interface"}
              article={"component_record_checkbox"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "interface", "component_record_code_editor") ? (
            <Component_record_code_editor
              section={"interface"}
              article={"component_record_code_editor"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(
            this.props,
            "interface",
            "component_record_drag_and_drop_list"
          ) ? (
            <Component_record_drag_and_drop_list
              section={"interface"}
              article={"component_record_drag_and_drop_list"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "interface", "component_record_keywords") ? (
            <Component_record_keywords
              section={"interface"}
              article={"component_record_keywords"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "interface", "component_record_notes") ? (
            <Component_record_notes
              section={"interface"}
              article={"component_record_notes"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(
            this.props,
            "interface",
            "component_record_select_date"
          ) ? (
            <Component_record_select_date
              section={"interface"}
              article={"component_record_select_date"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(
            this.props,
            "interface",
            "component_record_select_list"
          ) ? (
            <Component_record_select_list
              section={"interface"}
              article={"component_record_select_list"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(
            this.props,
            "interface",
            "component_record_select_object"
          ) ? (
            <Component_record_select_object
              section={"interface"}
              article={"component_record_select_object"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "interface", "component_record_textbox") ? (
            <Component_record_textbox
              section={"interface"}
              article={"component_record_textbox"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(
            this.props,
            "interface",
            "component_record_textbox_list"
          ) ? (
            <Component_record_textbox_list
              section={"interface"}
              article={"component_record_textbox_list"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "interface", "component_record_timestamp") ? (
            <Component_record_timestamp
              section={"interface"}
              article={"component_record_timestamp"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "interface", "search_component_overview") ? (
            <Search_component_overview
              section={"interface"}
              article={"search_component_overview"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(
            this.props,
            "interface",
            "component_search_filter_date_range"
          ) ? (
            <Component_search_filter_date_range
              section={"interface"}
              article={"component_search_filter_date_range"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(
            this.props,
            "interface",
            "component_search_filter_field"
          ) ? (
            <Component_search_filter_field
              section={"interface"}
              article={"component_search_filter_field"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(
            this.props,
            "interface",
            "component_search_filter_foreign_object"
          ) ? (
            <Component_search_filter_foreign_object
              section={"interface"}
              article={"component_search_filter_foreign_object"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(
            this.props,
            "interface",
            "component_search_filter_number_range"
          ) ? (
            <Component_search_filter_number_range
              section={"interface"}
              article={"component_search_filter_number_range"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "interface", "component_search_free_text") ? (
            <Component_search_free_text
              section={"interface"}
              article={"component_search_free_text"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "interface", "component_search_reset") ? (
            <Component_search_reset
              section={"interface"}
              article={"component_search_reset"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "interface", "component_search_results") ? (
            <Component_search_results
              section={"interface"}
              article={"component_search_results"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "interface", "component_search_sort") ? (
            <Component_search_sort
              section={"interface"}
              article={"component_search_sort"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "interface", "report_component_overview") ? (
            <Report_component_overview
              section={"interface"}
              article={"report_component_overview"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "interface", "component_report_table") ? (
            <Component_report_table
              section={"interface"}
              article={"component_report_table"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "interface", "component_report_html") ? (
            <Component_report_html
              section={"interface"}
              article={"component_report_html"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(
            this.props,
            "interface",
            "dashboard_component_overview"
          ) ? (
            <Dashboard_component_overview
              section={"interface"}
              article={"dashboard_component_overview"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(
            this.props,
            "interface",
            "component_dashboard_bar_chart"
          ) ? (
            <Component_dashboard_bar_chart
              section={"interface"}
              article={"component_dashboard_bar_chart"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(
            this.props,
            "interface",
            "component_dashboard_doughnut_chart"
          ) ? (
            <Component_dashboard_doughnut_chart
              section={"interface"}
              article={"component_dashboard_doughnut_chart"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(
            this.props,
            "interface",
            "component_dashboard_horizontal_bar_chart"
          ) ? (
            <Component_dashboard_horizontal_bar_chart
              section={"interface"}
              article={"component_dashboard_horizontal_bar_chart"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(
            this.props,
            "interface",
            "component_dashboard_line_chart"
          ) ? (
            <Component_dashboard_line_chart
              section={"interface"}
              article={"component_dashboard_line_chart"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(
            this.props,
            "interface",
            "component_dashboard_pie_chart"
          ) ? (
            <Component_dashboard_pie_chart
              section={"interface"}
              article={"component_dashboard_pie_chart"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(
            this.props,
            "interface",
            "component_dashboard_polar_chart"
          ) ? (
            <Component_dashboard_polar_chart
              section={"interface"}
              article={"component_dashboard_polar_chart"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "interface", "material_colors") ? (
            <Material_colors
              section={"interface"}
              article={"material_colors"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "interface", "material_icons") ? (
            <Material_icons
              section={"interface"}
              article={"material_icons"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "workflow", "workflow_overview") ? (
            <Workflow_Overview
              section={"workflow"}
              article={"workflow_overview"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "workflow", "application_events") ? (
            <Application_Events
              section={"workflow"}
              article={"application_events"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "workflow", "workflow_events") ? (
            <Workflow_Events
              section={"workflow"}
              article={"workflow_events"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "workflow", "nl_overview") ? (
            <NL_Overview
              section={"workflow"}
              article={"nl_overview"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "workflow", "nl_interface_getquerystring") ? (
            <NL_Interface_getQueryString
              section={"workflow"}
              article={"nl_interface_getquerystring"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(
            this.props,
            "workflow",
            "nl_interface_getquerystringobject"
          ) ? (
            <NL_Interface_getQueryStringObject
              section={"workflow"}
              article={"nl_interface_getquerystringobject"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "workflow", "nl_interface_isquerystring") ? (
            <NL_Interface_isQueryString
              section={"workflow"}
              article={"nl_interface_isquerystring"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "workflow", "nl_interface_navigateto") ? (
            <NL_Interface_navigateTo
              section={"workflow"}
              article={"nl_interface_navigateto"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "workflow", "nl_interface_updaterecord") ? (
            <NL_Interface_updateRecord
              section={"workflow"}
              article={"nl_interface_updaterecord"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "workflow", "nl_record_create") ? (
            <NL_Record_create
              section={"workflow"}
              article={"nl_record_create"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "workflow", "nl_record_read") ? (
            <NL_Record_read
              section={"workflow"}
              article={"nl_record_read"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "workflow", "nl_record_update") ? (
            <NL_Record_update
              section={"workflow"}
              article={"nl_record_read"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "workflow", "nl_record_replace") ? (
            <NL_Record_replace
              section={"workflow"}
              article={"nl_record_replace"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "workflow", "nl_record_delete") ? (
            <NL_Record_delete
              section={"workflow"}
              article={"nl_record_delete"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "workflow", "nl_record_search") ? (
            <NL_Record_search
              section={"workflow"}
              article={"nl_record_search"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "workflow", "nl_record_audit_delete") ? (
            <NL_Record_audit_delete
              section={"workflow"}
              article={"nl_record_audit_delete"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "workflow", "nl_authentication_authenticator") ? (
            <NL_Authentication_authenticator
              section={"workflow"}
              article={"nl_authentication_authenticator"}
              routeParams={this.props.routeParams}
            />
          ) : null}



          {this.show(this.props, "workflow", "nl_notification_create") ? (
            <NL_Notification_create
              section={"workflow"}
              article={"nl_notification_create"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "workflow", "nl_notification_view") ? (
            <NL_Notification_view
              section={"workflow"}
              article={"nl_notification_view"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "workflow", "nl_notification_markasread") ? (
            <NL_Notification_markAsRead
              section={"workflow"}
              article={"nl_notification_markasread"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "workflow", "nl_email_send") ? (
            <NL_Email_send
              section={"workflow"}
              article={"nl_email_send"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "workflow", "nl_pdf_create") ? (
            <NL_PDF_create
              section={"workflow"}
              article={"nl_pdf_create"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "workflow", "nl_sms_send") ? (
            <NL_SMS_send
              section={"workflow"}
              article={"nl_sms_send"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "workflow", "nl_geo_get") ? (
            <NL_Geo_get
              section={"workflow"}
              article={"nl_geo_get"}
              routeParams={this.props.routeParams}
            />
          ) : null}

          {this.show(this.props, "workflow", "nl_s3_init") ? (
            <NL_S3_init
              section={"workflow"}
              article={"nl_s3_init"}
              routeParams={this.props.routeParams}
            />
          ) : null}

          {this.show(this.props, "workflow", "nl_s3_delete") ? (
            <NL_S3_delete
              section={"workflow"}
              article={"nl_s3_delete"}
              routeParams={this.props.routeParams}
            />
          ) : null}

          {this.show(this.props, "workflow", "nl_s3_delete_files") ? (
            <NL_S3_delete_files
              section={"workflow"}
              article={"nl_s3_delete_files"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "workflow", "nl_s3_download") ? (
            <NL_S3_download
              section={"workflow"}
              article={"nl_s3_download"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "workflow", "nl_s3_download_files") ? (
            <NL_S3_download_files
              section={"workflow"}
              article={"nl_s3_download_files"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "workflow", "nl_s3_list") ? (
            <NL_S3_list
              section={"workflow"}
              article={"nl_s3_list"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "workflow", "nl_s3_upload") ? (
            <NL_S3_upload
              section={"workflow"}
              article={"nl_s3_upload"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "workflow", "nl_s3_upload_files") ? (
            <NL_S3_upload_files
              section={"workflow"}
              article={"nl_s3_upload_files"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "workflow", "nl_translate_init") ? (
            <NL_Translate_init
              section={"workflow"}
              article={"nl_translate_init"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "workflow", "nl_translate_translate") ? (
            <NL_Translate_translate
              section={"workflow"}
              article={"nl_translate_translate"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "workflow", "nl_translate_savecache") ? (
            <NL_Translate_saveCache
              section={"workflow"}
              article={"nl_translate_savecache"}
              routeParams={this.props.routeParams}
            />
          ) : null}



          {this.show(this.props, "security", "security_overview") ? (
            <Security_overview
              section={"security"}
              article={"security_overview"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "security", "system_permissions") ? (
            <System_permissions
              section={"security"}
              article={"system_permissions"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "security", "permissions_objects") ? (
            <Permissions_objects
              section={"security"}
              article={"permissions_objects"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "security", "permissions_rlp") ? (
            <Permissions_RLP
              section={"security"}
              article={"permissions_rlp"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "security", "permissions_rlp_settings") ? (
            <Permissions_RLP_Settings
              section={"security"}
              article={"permissions_rlp_settings"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "integration", "integration_overview") ? (
            <Integration_Overview
              section={"integration"}
              article={"integration_overview"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "integration", "nexoid_agent") ? (
            <Nexoid_Agent
              section={"integration"}
              article={"nexoid_agent"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "integration", "nexoid_agent_sso") ? (
            <Nexoid_Agent_SSO
              section={"integration"}
              article={"nexoid_agent_sso"}
              routeParams={this.props.routeParams}
            />
          ) : null}
          {this.show(this.props, "integration", "node_js_2_json") ? (
            <Tools_node_js_2_json
              section={"integration"}
              article={"node_js_2_json"}
              routeParams={this.props.routeParams}
            />
          ) : null}
        </Scrollbars>
      </div>
    );
  }
}

export default Knowlege;



// WEBPACK FOOTER //
// ./src/components/knowlege/Knowlege.js